import Cookies from "js-cookie";
import useSWR from "swr";
import API from "../../../services/apiHelpers";
import { ProductFamily } from "../../averagePrices/types";

export function useListOfPoultryProducts() {
  const url = "/api/v1/poultry/products/";
  const { data } = useSWR(url, () => API().get(url));

  return {
    data: data ? data.data : undefined,
  };
}

export function useDataForRaportCenowy(settings = {}) {
  const regionsList = settings.regions
    ? settings.regions.map(({ id }) => id).join(",")
    : undefined;

  const url = "/api/v1/poultry/";
  const { data } = useSWR([url, regionsList], () =>
    API().get(url, {
      params: {
        limit: 20,
        ordering: "-week_start_date",
        regions_list: regionsList,
      },
    })
  );

  return {
    data: data ? data.data : undefined,
  };
}

export function useMarketPrices(period, settings = {}) {
  const token = Cookies.get("user_token");
  const authHeader = token ? { Authorization: `Bearer ${token}` } : null;

  const regionsList = settings.regions
    ? settings.regions.map(({ id }) => id).join(",")
    : undefined;

  const url = "/api/v1/poultry/diagram/";
  const { data } = useSWR([url, period, regionsList], () =>
    API().get(url, {
      params: {
        period,
        regions_list: regionsList,
      },
      headers: authHeader,
    })
  );

  return { data: data ? data.data : undefined };
}

export function useListOfRegions() {
  const token = Cookies.get("user_token");
  const authHeader = token ? { Authorization: `Bearer ${token}` } : null;

  const url = "/api/v1/poultry/regions/";
  const { data } = useSWR(url, () =>
    API().get(url, {
      headers: authHeader,
    })
  );

  return {
    data: data ? data.data : undefined,
  };
}

export const addToProfile = (userId, settings, existingUserDefaults) => {
  const token = Cookies.get("user_token");

  const { products, regions } = settings;

  const newMarketDefaults = {
    product_family: ProductFamily.Poultry,
    user_id: userId,
    interested_products: products.map(({ id }) => id),
    regions: regions.map(({ id }) => id),
  };

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  if (existingUserDefaults) {
    // updating existing configuration
    return API().patch(
      `/api/v1/market-defaults/${existingUserDefaults.id}/`,
      newMarketDefaults,
      headers
    );
  }
  // user has no configuration yet
  return API().post("/api/v1/market-defaults/", newMarketDefaults, headers);
};
